import React from 'react'
import { Table } from '@ztechapps/webui.data-tools'
import { ListFooter } from './ListFooter'
import { useContext } from './Context'
import { ListRow } from './ListRow'

export const List = () => {
  const { newTasks } = useContext()

  return (
    <Table
      {...{
        foot: <ListFooter />,
        dataArray: newTasks,
        showEmptyContent: false,
        row: ListRow,
      }}
    />
  )
}
